<div class="trading-dashboard">
  <!-- Filter / header bar -->
  <div class="filters-card">
    <div class="filters-top-row">
      <h2>Wallet Balances</h2>

      <div class="net-summary" *ngIf="hasData()">
        <span class="label">Positions:</span>
        <span class="value">{{ totalPositions }}</span>

        <span class="label ms-3">Exchanges:</span>
        <span class="value">{{ distinctExchanges }}</span>

        <span class="label ms-3">Currencies:</span>
        <span class="value">{{ distinctCurrencies }}</span>
      </div>

      <div class="button-field ms-3" style="margin:0;">
        <button type="button" (click)="loadBalances()" [disabled]="loading">
          {{ loading ? 'Refreshing…' : 'Refresh' }}
        </button>
      </div>
    </div>

    <div class="filters-grid filters-grid--single" *ngIf="hasData()">
      <div class="field">
        <label for="exchangeFilter">Exchange</label>
        <select
          id="exchangeFilter"
          [(ngModel)]="selectedExchange"
          name="exchangeFilter"
        >
          <option value="ALL">All Exchanges</option>
          <option *ngFor="let ex of exchanges" [value]="ex">{{ ex }}</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Totals summary cards -->
  <div class="summary-grid" *ngIf="hasData()">
    <div class="summary-card">
      <h3>Total Balance</h3>
      <div class="summary-value">
        {{ totalBalance | number:'1.6-6' }}
      </div>
      <div class="summary-caption">
        Sum of Balance across filtered positions.
      </div>
    </div>

    <div class="summary-card">
      <h3>Total Available</h3>
      <div class="summary-value">
        {{ totalAvailable | number:'1.6-6' }}
      </div>
      <div class="summary-caption">
        Units available to trade.
      </div>
    </div>

    <div class="summary-card">
      <h3>Total Hold</h3>
      <div class="summary-value">
        {{ totalHold | number:'1.6-6' }}
      </div>
      <div class="summary-caption">
        Units currently on hold.
      </div>
    </div>
  </div>

  <!-- Status messages -->
  <div class="status" *ngIf="loading">
    Loading wallet balances…
  </div>

  <div class="status error" *ngIf="error">
    {{ error }}
  </div>

  <div class="status" *ngIf="!loading && !error && !hasData()">
    No wallet balances found.
  </div>

  <!-- Details table -->
  <div class="table-wrapper" *ngIf="!loading && !error && hasData()">
    <table class="pnl-table">
      <thead>
        <tr>
          <th>Exchange</th>
          <th>Currency</th>
          <th class="num">Balance</th>
          <th class="num">Available</th>
          <th class="num">Hold</th>
          <th>Snapshot Time</th>
          <th>Source</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of filteredBalances">
          <td>{{ b.Exchange }}</td>
          <td>{{ b.Currency }}</td>
          <td class="num">{{ b.Balance   | number:'1.6-6' }}</td>
          <td class="num">{{ b.Available | number:'1.6-6' }}</td>
          <td class="num">{{ b.Hold      | number:'1.6-6' }}</td>
          <td>{{ b.SnapshotTime | date:'yyyy-MM-dd HH:mm' }}</td>
          <td>{{ b.Source }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
